/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';
import './CommentaryActivity.scss';
import { currency } from 'services/Dates';
import { posNegWrapper } from 'services/Template';

const CommentaryActivity = (props) => {
  return (
    <div className="commentary-activity">
      <div className="commentary-header">
        <p className="observations-text">Observations</p>
        <p className="portfolio-change-text">Portfolio during the period</p>
        <div className="changeValue-box">
          <span
            className={`changeValue-number ${posNegWrapper(
              props.changeValue
            )}`}>
            {currency(props.changeValue)}
          </span>
        </div>
      </div>
      <ul>
        {props.commentary.map((comment, i) => (
          <li key={i}>
            <span dangerouslySetInnerHTML={{ __html: comment }}></span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CommentaryActivity;
